import Button from "./Button.jsx";
import { theme } from "../../theme.js";

export default function Form({children, onSubmit, disabled=false}) {
    return(
          <form onSubmit={onSubmit} style={styles(theme).form}>
            <div style={styles(theme).children}>
                {children}
            </div>
            <Button title="Submit" type="submit" disabled={disabled} />
          </form>
      );
    }

const styles = (theme) => ({
    form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: theme.spacing.md,
    padding: `${theme.spacing.md} 0`,
  },
  children: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.md,
  },
})